module.exports = __webpack_public_path__ + "img/05342379000131.2ab2db3b.png";